import Vue from 'vue'
import Vuex from 'vuex'
import router from '../router'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        apiBaseUrl: process.env.VUE_APP_API_BASE_URL || "https://api.fabricfour.com/api",
        user: null,
        jwt: null,
        isAuthenticated: false,
        isAdmin: false,
        isAuthor: false,
        showHomeHeader: true,
        courses: [],
        cart: [],
        requestOverlayText: null,
        requestErrorCode: null,
        requestBusy: false,
        breadCrumbs: null,
        siteDesign: null,
        hasDesign: false,
        themeCss: null,
        additionalProperties: null,
        siteId: null,
        divisions: []
    },
    getters: {
        getAdditionalProperties(state) {
            return state.additionalProperties;
        },
        getSiteId(state) {
            return state.siteId;
        },
        getSiteDesign(state) {
            return state.siteDesign;
        },
        getUser(state) {
            return state.user;
        },
        getThemeCss(state) {
            return state.themeCss;
        },
        getDivisions(state) {
            return state.divisions;
        },
    },
    mutations: {
        breadCrumbs(state, crumbs) {
            state.breadCrumbs = crumbs;
        },
        setRequestBusy(state, isBusy) {
            state.requestBusy = isBusy;
        },
        setSiteId(state, id) {
            state.siteId = id;
        },
        setAdditionalProperties(state, properties) {
            state.additionalProperties = properties;
        },
        setDivisions(state, divisions) {
            state.divisions = divisions;
        },
        setOverlayText(state, text) {
            state.requestOverlayText = text;
        },
        setErrorCode(state, code) {
            state.requestErrorCode = code;
        },
        loadCart(state) {
            if (localStorage.getItem("cartState")) {
                var cartState = JSON.parse(localStorage.getItem("cartState"));
                state.cart = cartState;
            }
        },
        addToCart(state, cartItem) {
            if (cartItem.price == 0 || cartItem.price === null) {
                router.push(`/courses/details/${cartItem.id}#enrol`);
            }
            else {

                if (state.cart.findIndex(x => x.name == cartItem.name) == -1) {

                    cartItem.couponCode = null;
                    cartItem.discountPercentage = null;
                    cartItem.discountedPrice = null;
                    cartItem.discountedPriceUsd = null;

                    state.cart.push(cartItem);
                    localStorage.setItem("cartState", JSON.stringify(state.cart));
                }

                if (router.currentRoute.name != "Cart")
                    router.push("/cart");
            }
        },
        removeFromCart(state, item) {
            var i = state.cart.findIndex(x => x.name == item.name);
            state.cart.splice(i, 1);
            localStorage.setItem("cartState", JSON.stringify(state.cart));
        },
        clearCart(state) {
            state.cart = [];
            localStorage.removeItem("cartState");
        },
        setUserState(state, userState) {
            if (userState == null) {
                state.isAuthenticated = false;
                state.user = null;
                state.jwt = null;
                localStorage.removeItem("userState");
            }
            else {
                state.isAuthenticated = true;
                state.user = userState.user;
                state.jwt = userState.jwt;
                localStorage.setItem("userState", JSON.stringify(userState));

                if (state.user.roles) {
                    state.isAdmin = state.user.roles.indexOf("admin") > -1;
                    state.isAuthor = state.user.roles.indexOf("author") > -1;
                }

                if (state.cart && state.cart.length > 0) {
                    router.replace("/cart");
                }
                else {
                    router.replace("/dashboard#loggedin");
                }
            }
        },
        loadUserState(state) {
            var userState = JSON.parse(localStorage.getItem("userState"));
            if (userState) {
                state.isAuthenticated = true;
                state.user = userState.user;
                state.jwt = userState.jwt;
                 
                if (state.user.roles) {
                    state.isAdmin = state.user.roles.indexOf("admin") > -1;
                    state.isAuthor = state.user.roles.indexOf("author") > -1;
                }
            }
        },
        setUser(state, user) {
            //used to update just the user when changes are made from the dashboard
            var localStoreUserState = JSON.parse(localStorage.getItem("userState"));
            state.user = user;
            localStoreUserState.user = user;
            localStorage.setItem("userState", JSON.stringify(localStoreUserState));
        },
        loadDesignState(state) {
            var designState = JSON.parse(localStorage.getItem("designState"));
            state.hasDesign = !!designState;
            state.siteDesign = designState;
            state.themeCss = designState?.css;
        },
        setDesign(state, design) {
            state.hasDesign = true;
            state.siteDesign = design;
            state.themeCss = design?.css;
            localStorage.setItem("designState", JSON.stringify(design));
        }
    },
    actions: {
    },
    modules: {
    }
})